import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import MasterClinicalRoomsModal from './MasterClinicalRooms_Modal';
import { deleteMasterClinicalRoom, getMasterClinicalRoomList } from '../actions/MasterClinicalRoomActions';
import Alert from 'react-s-alert';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../../components/SortingCustom';
import { resetFiltersAndSorting, alertConfirmation } from '../../../../../actions/utilAction';
import Tooltip from '../../../../../components/Tooltip';
import PaginatorCustom from '../../../../../components/paginationCustom';

class MasterClinicalRoomList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      masterClinicalRoomId: null,
    };

    this.filter = {
      sort_Column: 'id',
      sort_order: 'desc',
      searchText: '',
    };

    this.handleSearchClinicalRoom = this.handleSearchClinicalRoom.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getMasterClinicalRoomList(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }
  componentWillMount() {
    this.loadData();
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.postMasterClinicalRoomData && this.props.postMasterClinicalRoomData !== nextProps.postMasterClinicalRoomData) {
      this.loadData();
    }
    if (nextProps.deleteMasterClinicalRoom && this.props.deleteMasterClinicalRoom !== nextProps.deleteMasterClinicalRoom) {
      this.loadData();
    }
  }


  handleReset = () => {
    Alert.closeAll();
    this.setState({ masterClinicalRoomId: null });
    this.loadData();
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, masterClinicalRoomId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, masterClinicalRoomId) => {
    this.props.deleteMasterClinicalRoom(masterClinicalRoomId);
    Alert.closeAll();
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Are you sure you want to delete this master therapy room?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, masterClinicalRoomId: obj.id });
  }

  handleSearchClinicalRoom(event) {
    if (event.roomName !== undefined) {
    }
  }
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('MasterClinicalRoomListForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }
  renderData() {
    if (!this.props.masterClinicalRoomList || !this.props.masterClinicalRoomList.length) {
      return (
        <tr>
          <td colSpan="4">
              <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return this.props.masterClinicalRoomList.map((Obj, index) => {
      return (
        <tr key={index}>
          <td>{Obj.roomName}</td>
          <td>
            {Obj.description && Obj.description.length > 0 ?
              <Tooltip Description={Obj.description} />
              : null}
            {Obj.description != null && Obj.description.length > 75 ? SubString(Obj.description, 75) : Obj.description != null ? Obj.description : 'N/A'}
          </td>
          <td>{Obj.roomCapacity}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }
  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Manage Therapy Room</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                {this.props.addPermission ?
                  <RaisedButton label="Add Therapy Room" primary={true} onTouchTap={this.handleOpen} />
                  :null}
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchClinicalRoom)}>
                        <Field
                          name="roomName"
                          floatingLabelText="Search"
                          maxLength='50'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">                     
                        <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>                     
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <MasterClinicalRoomsModal masterClinicalRoomId={this.state.masterClinicalRoomId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="25%"><SortingCustom setSortColumn={this.setSortColumn} columnName='roomName' displayName='Room Name' /></th>
                        <th width="50%"><SortingCustom setSortColumn={this.setSortColumn} columnName='description' displayName='Description' /></th>
                        <th width="15%">Capacity</th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="10%">Actions</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData()}
                    </tbody>
                  </table>
                  {this.props.metaData && this.props.metaData.totalPages ?
                    <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MasterClinicalRoomList = reduxForm({
  form: 'MasterClinicalRoomListForm',
})(MasterClinicalRoomList);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [], masterClinicalRoomList = [], metaData = null;
  if (state.masterClinicalRoom.masterClinicalRoomList && state.masterClinicalRoom.masterClinicalRoomList.data) {
    masterClinicalRoomList = state.masterClinicalRoom.masterClinicalRoomList.data;
    metaData = state.masterClinicalRoom.masterClinicalRoomList.meta;
  }
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_CLINICALROOMS_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CLINICALROOMS_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CLINICALROOMS_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_CLINICALROOMS_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    loading: state.masterClinicalRoom.loading,
    masterClinicalRoomList: masterClinicalRoomList,
    postMasterClinicalRoomData: state.masterClinicalRoom.postMasterClinicalRoomData,
    deleteMasterClinicalRoom: state.masterClinicalRoom.deleteMasterClinicalRoom,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
    metaData: metaData,
  };
}
export default connect(mapStateToProps, { getMasterClinicalRoomList, deleteMasterClinicalRoom })(MasterClinicalRoomList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/components/index.js